import { describeZonesError } from '../../../helpers/setting';

/**
 * What the settings message box shows. Most messages are titled 'settings'
 * and name the panel (subtitle) and the kind of change (theme).
 */
export const settingsMessage = (
  subtitle,
  theme,
  message,
  title = 'settings',
) => ({
  title: [title],
  subtitle,
  theme,
  message,
});

/** A message with only a title and text. */
export const plainMessage = (title, message) =>
  settingsMessage('', '', message, title);

/**
 * A settings write the server refused or never got. `asList` matches panels
 * whose messages are lists of lines.
 */
export const saveFailedMessage = (
  subtitle,
  theme,
  error,
  { asList = false } = {},
) => {
  const reason = describeZonesError(error);
  return settingsMessage(
    subtitle,
    theme,
    asList ? [reason] : reason,
    'save failed',
  );
};
